module.exports = __webpack_public_path__ + "img/car.e62d0889.svg";